var JobMatchesQueryFilter = /** @class */ (function () {
    function JobMatchesQueryFilter(workflowStep) {
        this.clientOrBU = [];
        this.recruiters = [];
        this.roleList = [];
        this.requisitionStates = [];
        this.requisitionNums = [];
        this.jobMatchIds = [];
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.email = "";
        this.workflowStates = [];
        this.workflowSteps = [];
        this.outreachStateFilters = [];
        if (!_.isUndefined(workflowStep) && !_.isNull(workflowStep)) {
            this.workflowSteps = angular.copy(workflowStep);
        }
        this.vendors = [];
        this.searchString = "";
        this.pageNum = "";
        this.column;
        this.sortDirection;
        this.filtered = false;
        this.userIdScope = [];
        this.forwardedUserIds = [];
        this.isUnAssignedCandidate = false;
        //visibility filters
        this.isUnassigned = false;
        this.isAssignedToMe = false;
        this.isAssignedToAll = false;
    }
    return JobMatchesQueryFilter;
}());
export { JobMatchesQueryFilter };
//# sourceMappingURL=jobMatchesQueryFilter.js.map